import { React, useState } from 'react';
import { Link } from 'react-router-dom'

import item from '../../assets/fake-data/item';

const About = () => {

    const [data] = useState(
        {
            subtitle: 'Rodex Hostel',

            desc1: 'Rodex Hostel es el lugar ideal para viajeros que buscan un alojamiento cómodo, accesible y con un ambiente cálido y social en San Miguel de Tucumán. Ubicado en pleno centro, en Catamarca 72, y cerca de la Casa Histórica, ofrecemos habitaciones privadas y compartidas, desayuno incluido, piscina, espacios de coworking, clases de yoga gratuitas y actividades todas las semanas para que siempre haya algo para hacer. En Rodex creamos una experiencia auténtica, pensada para quienes quieren descansar, conocer gente y disfrutar Tucumán desde un espacio relajado y con espíritu de comunidad.',
            desc2: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occae cat cupidatat non proident, sunt in culpa qui officia dese runt mollit anim id est laborum velit esse cillum dolore eu fugiat nulla pariatu epteur sint occaecat',
        }
    )

    return (
        <section className="tf-section section-about">
            <div className="container">
                <div className="row reverse" style={{ alignItems: 'flex-start' }}>
                    <div className="col-xl-7 col-md-12">
                        <div className="video-wrapper" style={{ display: 'flex', justifyContent: 'center' }}>
                            <div style={{ position: 'relative', width: '100%', maxWidth: '360px', aspectRatio: '9/16', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
                                <iframe
                                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                                    src="https://www.youtube.com/embed/wRuMW4YDI2E"
                                    title="Rodex Hostel"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5 col-md-12">
                        <div className="block-text pt-0">
                            <h5 className="sub-title mb-10 text-black" data-aos="fade-up" data-aos-duration="1000" style={{ marginTop: 0, lineHeight: 1 }}>{data.subtitle}</h5>

                            <p className="fs-21 mb-33 text-black" data-aos="fade-up" data-aos-duration="1000">{data.desc1}</p>

                            <Link to="/nosotros" className="btn-action style-2" data-aos="fade-up" data-aos-duration="1200">Nosotros</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;